import React from "react";
import { List, ListItem, ListItemText, Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {
  formatDate_12h,
  detailsTabsBoxStyle,
  overviewListItemStyles,
} from "../../services/Utils";
import { Grid } from "@mui/material";

const VehicleGroupDetailsTab = ({ groupData, isLoading }) => {
  if (isLoading) return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", margin: "10%" }}><CircularProgress /></div>;

  return (
    <Box {...detailsTabsBoxStyle}>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
          <List>
            <ListItem {...overviewListItemStyles}>
              <ListItemText
                primary="Group Name"
                secondary={groupData?.vehicleGroupName || "-"}
              />
            </ListItem>
            <ListItem {...overviewListItemStyles}>
              <ListItemText
                primary="Group Id"
                secondary={groupData?.vehicleGroupId || "-"}
              />
            </ListItem>

            <ListItem {...overviewListItemStyles}>
              <ListItemText
                primary="Description"
                secondary={groupData?.description || "-"}
              />
            </ListItem>

            <ListItem {...overviewListItemStyles}>
              <ListItemText
                primary="Created Date"
                secondary={formatDate_12h(groupData?.createdAt)}
              />
            </ListItem>
            <ListItem {...overviewListItemStyles}>
              <ListItemText
                primary="Created By"
                secondary={groupData?.createdBy || "-"}
              />
            </ListItem>
          </List>
        </Grid>

        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }} >
          <List>
            <ListItem {...overviewListItemStyles}>
              <ListItemText
                primary="Group Updated Date"
                secondary={formatDate_12h(groupData?.updatedAt)}
              />
            </ListItem>
            <ListItem {...overviewListItemStyles}>
              <ListItemText
                primary="Updated By"
                secondary={groupData?.updatedBy || "-"}
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VehicleGroupDetailsTab;
